import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00aa775e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-bg-[#FFF] tw-rounded tw-relative current_scan" }
const _hoisted_2 = {
  id: "dash-latest-scan-title",
  class: "tw-flex tw-px-[20px] tw-bg-[#FCFCFD] tw-justify-between tw-py-[25px] tw-text-[#211F58] tw-text-[18px] tw-font-semibold current_scan_title"
}
const _hoisted_3 = { "data-cy": "dash-latest-scan-title" }
const _hoisted_4 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[182px]"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-p-[20px]"
}
const _hoisted_6 = { class: "tw-gap-[20px] content_current_scan" }
const _hoisted_7 = { class: "tw-flex-1 tw-gap-[6px]" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-justify-between tw-pb-[6px]" }
const _hoisted_9 = { class: "tw-text-[13px] tw-font-medium tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_10 = { class: "tw-flex tw-items-center tw-justify-between tw-pb-[6px]" }
const _hoisted_11 = { class: "tw-text-[13px] tw-font-medium tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_12 = { class: "tw-text-[13px] tw-font-medium tw-text-[#878787] tw-leading-[130%]" }
const _hoisted_13 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_14 = { class: "tw-text-[13px] tw-font-medium tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_15 = { class: "tw-text-[13px] tw-font-[400] tw-text-[#878787] tw-leading-[130%]" }
const _hoisted_16 = { class: "tw-flex-1" }
const _hoisted_17 = { class: "tw-flex tw-items-center tw-justify-between tw-pb-[6px]" }
const _hoisted_18 = { class: "tw-text-[13px] tw-font-medium tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_19 = { class: "tw-text-[11px] tw-font-medium tw-text-[#878787] tw-leading-[130%] type__scan" }
const _hoisted_20 = { class: "tw-flex tw-items-center tw-justify-between tw-pb-[6px]" }
const _hoisted_21 = { class: "tw-text-[13px] tw-font-medium tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_22 = { class: "tw-text-[13px] tw-font-[400] tw-text-[#878787] tw-leading-[130%]" }
const _hoisted_23 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_24 = { class: "tw-text-[13px] tw-font-medium tw-leading-[130%] tw-text-[#211F58]" }
const _hoisted_25 = { class: "tw-text-[13px] tw-font-[400] tw-text-[#878787] tw-leading-[130%]" }
const _hoisted_26 = { class: "tw-pt-[20px]" }
const _hoisted_27 = {
  key: 2,
  class: "tw-h-[182px]"
}

import { getComponentUiText, getElapsedTime } from "@/utils/utilities";
import IssueNumberBlocks from "@/components/scanning/IssueNumberBlocks.vue";
import { computed, ref } from "vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import DummyCard from "./dummyCard.vue";
import dayjs from "dayjs";

export default /*#__PURE__*/_defineComponent({
  __name: 'currentScan',
  props: {
  currentScan: {
    type: Object,
    required: true,
  },
  isLoading: {
    type: Boolean,
    required: true,
  },
},
  emits: ["button:click"],
  setup(__props, { emit: emits }) {

const props = __props;





const isShowDummyCard = computed(() => {
  return props.currentScan?.loading && !props.currentScan?.runStatusId;
});

const listStatusId = ref<any>({
  ok: "100%",
  start: "0%",
  inprog: "50%",
  time: "100%",
  canc: "100%",
  fail: "100%",
  cap: "100%",
});
const getProgress = (statusId) => {
  return listStatusId.value[statusId];
};

const formatDate = (isoDateString) => {
  if (isoDateString) {
    return convertUTCTimeToLocalTime(
      isoDateString.toString(),
      undefined,
      "HH:mm",
    );
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-dashboard-latest-scan-title-1")) + " " + _toDisplayString(`${__props.currentScan?.name ? `- ${__props.currentScan?.name || ""}` : ""}`), 1)
    ]),
    (__props.isLoading || !__props.currentScan?.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : (
        (__props.currentScan?.loading && __props.currentScan?.runStatusId) || isShowDummyCard.value
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(getComponentUiText)("app-manage-orgs-header-status-1")), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(`tw-text-[11px] tw-font-[400] tw-rounded tw-text-[#878787] tw-leading-[130%] tw-py-[3px] tw-px-[5px] ${__props.currentScan?.runStatusId}`)
                  }, _toDisplayString(__props.currentScan?.runStatus), 3)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessment-title-progress-1",
                  )), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(getProgress(__props.currentScan?.runStatusId)), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(getComponentUiText)("app-scan-scanning-scan-elapsed-time-1")), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(getElapsedTime)(__props.currentScan?.startedAt, __props.currentScan?.endedAt)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(getComponentUiText)("app-dashboard-current-scan-type-1")), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(__props.currentScan?.type), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessments-checklists-assessment-details-card-label-1",
                  )), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(formatDate(__props.currentScan?.startedAt)), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(getComponentUiText)(
                    "app-dashboard-current-scan-time-remaining-1",
                  )), 1),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(getComponentUiText)("app-dashboard-current-scan-unknown-1")), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(IssueNumberBlocks, {
                "display-border": false,
                "web-services-id": '1',
                "domain-id": '1',
                severity: {
            critical: __props.currentScan?.critical,
            high: __props.currentScan?.high,
            medium: __props.currentScan?.med,
            low: __props.currentScan?.low,
          }
              }, null, 8, ["severity"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_27)),
    (isShowDummyCard.value && !__props.isLoading)
      ? (_openBlock(), _createBlock(DummyCard, {
          key: 3,
          title: _unref(getComponentUiText)('app-dashboard-dummy-title-current-scan-1'),
          "title-button": 
        _unref(getComponentUiText)('app-dashboard-dummy-button-title-setup-scan-1')
      ,
          "title-class": 'tw-w-[276px]',
          "custom-class": 'tw-top-[67px]',
          "onButton:click": _cache[0] || (_cache[0] = () => emits('button:click'))
        }, null, 8, ["title", "title-button"]))
      : _createCommentVNode("", true)
  ]))
}
}

})